module.exports = __webpack_public_path__ + "img/arh_13.10529932.jpg";